import { useSelector } from "react-redux";
import "./AdSysCode.scss";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog.jsx";
import CircularButton, {
  CustomLoadingButton,
} from "../../../components/ui/CustomButton.jsx";
import newRequest from "../../../utils/newRequest.js";
import { showToast } from "../../../toastService.js";
import {
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  Tooltip,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
  Select,
  MenuItem
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { FiSearch } from "react-icons/fi";
import { motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { FaSave } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import { GridLoader, ScaleLoader } from "react-spinners";
import { muiSelectStyles_dark, muiSelectStyles_light } from "../../../components/ui/CustomSelect.jsx";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { MdAdd, MdArrowBackIos, MdClose, MdDelete } from "react-icons/md";
import { ToggleSwitch } from "../../../components/toogle/ToggleSwitch.jsx";

const AdSysCode = () => {
  const { t } = useTranslation();
  const { currentTheme } = useSelector((state) => state.theme);
  const { currentUser } = useSelector((state) => state.user);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [confirmDialogAction, setConfirmDialogAction] = useState("None");
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const [notifyDialogText, setNotifyDialogText] = useState("Text");
  const [isLoading, setIsLoading] = useState(true);
  const [systemTypes, setSystemTypes] = useState([]);
  const [selectedSystemType, setSelectedSystemType] = useState({});
  const [systemCodes, setSystemCodes] = useState([]);
  const [selectedSystemCode, setSelectedSystemCode] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [currencyAction, setCurrencyAction] = useState("");
  const [isCodeDialogOpened, setIsCodeDialogOpened] = useState(false);
  const [newCode, setNewCode] = useState(null);
  const [newName, setNewName] = useState(null);
  const [newGrouping, setNewGrouping] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [currentPage, setCurrentPage] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();
  const showBack = location.state?.showBack || "N";
  const favMenu = location.state?.favMenu || "N";
  const menuDocid = location.state?.menuDocid || undefined;
  const nameRef = useRef(null);

  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
  };


  const slicedSysCodes = systemCodes.slice(
    currentPage * rowsPerPage,
    currentPage * rowsPerPage + rowsPerPage
  );

  const handleRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 8));
    setCurrentPage(0);
  };

  const handleAddSysCode = async () => {
    try {
      if (!newCode) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter code!`);
        setIsNotifyDialogOpen(true);
        return;
      }
      if (!newName) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please entername!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      setIsLoading(true);
      const res = await newRequest.post(
        "/sysCode/add/",
        {
          sys_type: selectedSystemType.sys_type,
          sys_code: newCode,
          sys_name: newName,
          sys_grouping: newGrouping
        }
      );
      await fetchSystemCodes(selectedSystemType.sys_type);
      setNewCode(null);
      setNewName(null);
      setNewGrouping(null);
      setIsCodeDialogOpened(false);
      setIsLoading(false);
      showToast("Code Added!", "success");
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  const handleAddSysType = async () => {
    try {
      if (!newCode) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter code!`);
        setIsNotifyDialogOpen(true);
        return;
      }
      if (!newName) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please entername!`);
        setIsNotifyDialogOpen(true);
        return;
      }
      setIsLoading(true);
      const res = await newRequest.post(
        "/sysType/add/",
        {
          sys_type: newCode,
          sys_name: newName,
        }
      );
      await fetchSystemTypes();
      setNewCode(null);
      setNewName(null);
      setNewGrouping(null);
      setIsCodeDialogOpened(false);
      setIsLoading(false);
      showToast("Type Added!", "success");
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  const [objectToAction, setObjectToAction] = useState({
    object_id: "",
    action_text: "",
    action_invoked: "",
  });


  const fetchSystemTypes = async () => {
    try {
      setIsLoading(true);
      const res = await newRequest.post("/sysType/findAll", { result_limit: 10 });
      setSystemTypes(res.data);
      setSelectedSystemType(res.data[0]);
      await fetchSystemCodes(res.data[0].sys_type);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearchSysTypes = async () => {
    try {
      setIsLoading(true);
      if (searchTerm) {
        const res = await newRequest.post("/sysType/search", { search_input: searchTerm });
        setSystemTypes(res.data);
        setSelectedSystemType(res.data[0]);
        await fetchSystemCodes(res.data[0].sys_type);
      } else {
        fetchSystemTypes();
      }
    } catch (error) {
      console.error("Error searching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchSystemCodes = async (sysType) => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: sysType });
      // console.log(`sysCode/findAll  ${JSON.stringify(res.data, null, 2)}`);
      setSystemCodes(res.data);
      if (res.data) {
        setSelectedSystemCode(res.data[0]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchSystemTypes();
  }, []);

  const filteredSysTypes = systemTypes.filter(
    (item) =>
      item.sys_type?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.sys_name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    try {
      setSystemCodes([]);
      fetchSystemCodes(selectedSystemType?.sys_type);
    } catch (error) {
      console.log(error);
    }
  }, [selectedSystemType]);


  // const handleSysCodeChange = (e, rowId) => {
  //   try {
  //     const { name, value } = e.target;
  //     const updatedData = [...systemCodes];
  //     const rowIndex = updatedData.findIndex(item => item._id === rowId);

  //     if (rowIndex === -1) {
  //       console.log('Row not found');
  //     }

  //     updatedData[rowIndex][name] = value;
  //     updatedData[rowIndex]["changed_xx"] = "Y";

  //     // console.log(`rowId is ${rowId} handleLimitChange updatedData  \n${JSON.stringify(updatedData, null, 2)}`);
  //     setSystemCodes(updatedData);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const handleSysCodeChange = (value, rowId, field) => {
    setSystemCodes((prevData) =>
      prevData.map((item) =>
        item._id === rowId
          ? { ...item, [field]: value, changed_xx: "Y" }
          : item
      )
    );
  };

  const handleConfirm = async () => {
    try {
      if (confirmDialogAction === "deleteCode") {
        const res = await newRequest.delete(`/sysCode/del/${objectToAction.object_id}`);
        fetchSystemCodes(selectedSystemType.sys_type);
      }
    } catch (err) {
      console.log(err);
    }
    // Close the dialog
    setIsConfirmDialogOpen(false);
  };

  const handleCancel = () => {
    setIsConfirmDialogOpen(false);
  };



  const saveRecord = async (e) => {
    // e.preventDefault();
    try {
      setIsLoading(true);
      // Simulate delay for 5 seconds
      // await new Promise((resolve) => setTimeout(resolve, 5000));

      const changedCodes = systemCodes.filter((obj) => obj.changed_xx === "Y");

      // console.log(`changedCodes  ${JSON.stringify(changedCodes, null, 2)}`);

      for (let i = 0; i < changedCodes.length; i++) {
        const res = await newRequest.put(
          `/sysCode/upd/${changedCodes[i]._id}`,
          {
            sys_code: changedCodes[i].sys_code,
            sys_name: changedCodes[i].sys_name,
            sys_grouping: changedCodes[i].sys_grouping,
            sys_enabled: changedCodes[i].sys_enabled
          }
        );
      }

      showToast("Updated!", "success");
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="ad-sys-code">
      {isLoading ? (
        <div className="no-content">
          <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
        </div>
      ) : (
        <motion.div
          className="sys-code-main-wrapper"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}>
          <div className="syscode-center-wrapper">
            <div className="center-details">
              <div className="center-navbar">
                <div className="navbar-left">
                  <span className="page-title"> {selectedSystemType?.sys_type} </span>
                </div>
                <div className="navbar-right">
                  <span
                    className="selected-type"
                    style={{ width: "max-content" }}
                  >
                    {selectedSystemType?.sys_access_level}
                  </span>
                  {!["System", "Extensible"].includes(selectedSystemType?.sys_access_level) &&
                    <CustomLoadingButton
                      currentTheme={currentTheme}
                      iconPosition="end"
                      borderRadiusType="both"
                      variant="tint"
                      color="#00D37F"
                      tooltip="Save changes"
                      endIcon={<FaSave />}
                      onClick={saveRecord}
                    >
                      {t('save')}
                    </CustomLoadingButton>}
                  {!["System", "Extensible"].includes(selectedSystemType?.sys_access_level) &&
                    <CustomLoadingButton
                      currentTheme={currentTheme}
                      iconPosition="end"
                      borderRadiusType="both"
                      variant="tint"
                      color="#0ea5a4"
                      tooltip={`Add new code to ${selectedSystemType?.sys_type}`}
                      endIcon={<MdAdd />}
                      onClick={() => {
                        try {
                          if (nameRef.current) {
                            nameRef.current.focus();
                          }
                          setCurrencyAction("addSysCode");
                          setIsCodeDialogOpened(true);
                        } catch (error) {
                          console.log(error);
                        }
                      }}
                    >
                      {t('addCode')}
                    </CustomLoadingButton>}
                </div>
              </div>
              <div className="table-content">
                <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                  <Table sx={{ width: "max-content", border: 'none' }}>
                    <TableHead className="tablehead">
                      <TableRow className="tablerow">
                        <TableCell className="table-cell" style={{ maxWidth: "50px", fontWeight: "bold", display: "flex", justifyContent: "center" }}>
                          #
                        </TableCell>
                        <TableCell className="table-cell" style={{ maxWidth: "200px" }}>
                          <span>{t('code').toUpperCase()}</span>
                        </TableCell>
                        <TableCell className="table-cell" style={{ width: "auto" }}>
                          <span>{t('name').toUpperCase()}</span>
                        </TableCell>
                        <TableCell className="table-cell" style={{ maxWidth: "150px" }}>
                          <span>{t('grouping').toUpperCase()}</span>
                        </TableCell>
                        <TableCell className="table-cell" style={{ maxWidth: "100px" }}>
                          <span>{t('enabled').toUpperCase()}</span>
                        </TableCell>
                        {!["System", "Extensible"].includes(selectedSystemType?.sys_access_level) &&
                          <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                            <span>{t('action').toUpperCase()}</span>
                          </TableCell>}
                      </TableRow>
                    </TableHead>
                    <TableBody className="tablebody">
                      {slicedSysCodes?.map((row, index) => (
                        <TableRow
                          key={row._id}
                          className={`${selectedSystemCode?._id === row._id ? "tablerow current" : "tablerow"}`}
                          onClick={() => setSelectedSystemCode(row)}
                        >
                          <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                            {currentPage * rowsPerPage + index + 1}
                          </TableCell>
                          <TableCell className="table-cell left" style={{ maxWidth: "150px" }}>
                            {/* <div className="input-item-with-label">
                              <input
                                id="sys_code"
                                name="sys_code"
                                value={row?.sys_code}
                                onChange={(e) => handleSysCodeChange(e.target.value, row._id, "sys_code")}
                                style={{ width: "100%" }}
                                className="form-input-item table"
                                disabled
                              />
                            </div> */}
                            <span className="sub-title">{row?.sys_code}</span>
                          </TableCell>
                          <TableCell className="table-cell left" style={{ width: "auto" }}>
                            <div className="input-item-with-label" style={{ width: "100%" }}>
                              <input
                                id="sys_name"
                                name="sys_name"
                                value={row?.sys_name}
                                onChange={(e) => handleSysCodeChange(e.target.value, row._id, "sys_name")}
                                style={{ width: "100%" }}
                                className="form-input-item table"
                                disabled={["System", "Extensible"].includes(selectedSystemType?.sys_access_level)}
                              />
                            </div>
                          </TableCell>
                          <TableCell className="table-cell" style={{ maxWidth: "150px" }}>
                            <div className="input-item-with-label">
                              <input
                                id="sys_grouping"
                                name="sys_grouping"
                                value={row?.sys_grouping}
                                onChange={(e) => handleSysCodeChange(e.target.value, row._id, "sys_grouping")}
                                style={{ width: "100%" }}
                                className="form-input-item table"
                                disabled={["System", "Extensible"].includes(selectedSystemType?.sys_access_level)}
                              />
                            </div>
                          </TableCell>
                          <TableCell className="table-cell" style={{ maxWidth: "100px" }}>
                            <ToggleSwitch
                              id={row._id}
                              value={row.sys_enabled}
                              onChange={(newValue) => handleSysCodeChange(newValue, row._id, "sys_enabled")}
                              label=""
                              labelPosition="end"
                              labelWidth="max-content"
                              border="N"
                            />
                          </TableCell>
                          {!["System", "Extensible"].includes(selectedSystemType?.sys_access_level) &&
                            <TableCell className="table-cell" style={{ alignItems: "center", maxWidth: "100px", fontWeight: "bold" }}>
                              <CircularButton
                                currentTheme={currentTheme}
                                onClick={() => {
                                  try {
                                    let action_text = `Delete code ${row?.sys_name}?`;
                                    setObjectToAction({
                                      object_id: row._id,
                                      action_text: action_text,
                                      new_doc_status: "deleteCode",
                                    });

                                    setConfirmDialogAction("deleteCode");
                                    setIsConfirmDialogOpen(true);
                                  } catch (error) {
                                    console.log(error);
                                  }
                                }}
                                color="#E53935"
                                icon={<MdDelete />}
                                width={"30px"}
                                height={"30px"} />
                            </TableCell>}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  {systemCodes?.length > rowsPerPage &&
                    <TablePagination
                      rowsPerPageOptions={[8]}
                      rowsPerPage={rowsPerPage}
                      onRowsPerPageChange={handleRowsPerPage}
                      component="div"
                      count={systemCodes?.length}
                      rows={systemCodes}
                      page={currentPage}
                      onPageChange={handlePageChange}
                    />}
                </TableContainer>
              </div>
            </div>
          </div>
          <div className="right-wrapper">
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", gap: "5px", width: "100%" }}>
              <div className="homeSearch">
                <FiSearch className="homeSearchIcon" />
                <input
                  className="homeSearchInput"
                  type="text"
                  placeholder={t('search')}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') handleSearchSysTypes();
                  }}
                />
                {searchTerm?.length > 0 ? (
                  <MdClose
                    className="homeSearchClear"
                    onClick={async () => {
                      try {
                        await fetchSystemTypes();
                        setSearchTerm("");
                      } catch (error) {
                        console.log(error);
                      }
                    }}
                  />
                ) : (
                  <span className="homeSearchClearPlaceholder" />
                )}
              </div>

              {/* This part shows if the menu was opened from home screen */}
              {showBack === "Y" && <hr className="separator-v" />}
              {showBack === "Y" &&
                <span className="back-icon" onClick={() => navigate(-1)}>
                  <MdArrowBackIos size={24} />
                </span>}
            </div>
            {["admin", "superadmin"].includes(currentUser?.user_type_xx) &&
              <CustomLoadingButton
                currentTheme={currentTheme}
                iconPosition="end"
                endIcon={<MdAdd />}
                style={{ width: "100%" }}
                variant="tint"
                color="#0ea5a4"
                tooltip={`Add new type`}
                onClick={() => {
                  try {
                    if (nameRef.current) {
                      nameRef.current.focus();
                    }
                    setCurrencyAction("addSysType");
                    setIsCodeDialogOpened(true);
                  } catch (error) {
                    console.log(error);
                  }
                }}
              >
                {t('addType')}
              </CustomLoadingButton>}
            <div className="options-list">
              {systemTypes?.map((stype) => (
                <>
                  <span
                    key={stype._id}
                    className={`${selectedSystemType?._id === stype?._id
                      ? "single-option active"
                      : "single-option"
                      }`}
                    onClick={async () => {
                      try {
                        await fetchSystemCodes(stype?.sys_type);
                        setSelectedSystemType(stype);
                        setCurrentPage(0);
                      } catch (error) {
                        console.log(error);
                      }
                    }}
                  >
                    <div className="title-row">
                      <span className="cy-title">{stype?.sys_type}</span>
                    </div>
                  </span>
                  {/* <hr className="separator-h" /> */}
                </>
              ))}
            </div>
          </div>
        </motion.div>
      )}
      {/* Dialog to notify user about changes being saved */}
      <Dialog open={isNotifyDialogOpen}
        onClose={() => setIsNotifyDialogOpen(false)}
       PaperProps={{
          sx: {
            borderRadius: "16px",
            backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
            color: currentTheme === "dark" ? "#fff" : "#000",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          },
        }}>
        <DialogTitle>{notifyDialogTitle}</DialogTitle>
        <DialogContent>
          <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
        </DialogContent>
        <DialogActions>
          <CustomLoadingButton onClick={() => setIsNotifyDialogOpen(false)}>Close</CustomLoadingButton>
        </DialogActions>
      </Dialog>
      {/* Confirm Dialog */}
      <ConfirmDialog
        isOpen={isConfirmDialogOpen}
        onClose={handleCancel}
        onConfirm={handleConfirm}
        dialogTitle={t('confirmation')}
        dialogContent={<p>{objectToAction.action_text}</p>}
      />
      {isCodeDialogOpened && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">{`${currencyAction === "addSysCode" ? "ADD CODE" : "ADD TYPE"
                }`}</h1>
              <CircularButton
                currentTheme={currentTheme}
                onClick={() => {
                  try {
                    setNewCode(null);
                    setNewName(null);
                    setNewGrouping(null);
                    setIsCodeDialogOpened(false);
                  } catch (error) {
                    console.log(error);
                  }
                }} icon={<IoClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <div className="input-item-with-label">
                <label
                  htmlFor="newName"
                  className="form-dropdown-label"
                  style={{ width: "130px" }}
                >
                  {t('name').toUpperCase()}
                </label>
                <input
                  ref={nameRef}
                  id="newName"
                  name="newName"
                  type="text"
                  placeholder="NAME"
                  value={newName}
                  className="form-input-item"
                  style={{ width: "250px" }}
                  onChange={(e) => setNewName(e.target.value)}
                />
              </div>
              <div className="input-item-with-label">
                <label
                  htmlFor="newCode"
                  className="form-dropdown-label"
                  style={{ width: "130px" }}
                >
                  {currencyAction === "addSysCode" ? `${t('code').toUpperCase()}` : `${t('type').toUpperCase()}`}
                </label>
                <input
                  id="newCode"
                  name="newCode"
                  type="text"
                  placeholder={
                    currencyAction === "addSysCode" ? `${t('code').toUpperCase()}` : `${t('type').toUpperCase()}`
                  }
                  value={newCode}
                  className="form-input-item"
                  style={{ width: "150px" }}
                  onChange={(e) => {
                    try {
                      setNewCode(e.target.value);
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                />
              </div>
              {currencyAction === "addSysCode" && (
                <div className="input-item-with-label">
                  <label
                    htmlFor="newGrouping"
                    className="form-dropdown-label"
                    style={{ width: "130px" }}
                  >
                    {t('grouping').toUpperCase()}
                  </label>
                  <input
                    id="newGrouping"
                    name="newGrouping"
                    type="text"
                    placeholder={t('grouping').toUpperCase()}
                    value={newGrouping}
                    className="form-input-item"
                    style={{ width: "150px" }}
                    onChange={(e) => setNewGrouping(e.target.value)}
                  />
                </div>
              )}
            </div>
            <div className="overlay-actions">
              {currencyAction === "addSysCode" && (
                <CustomLoadingButton currentTheme={currentTheme} onClick={handleAddSysCode}>{t('add').toUpperCase()}</CustomLoadingButton>
              )}
              {currencyAction === "addSysType" && (
                <CustomLoadingButton currentTheme={currentTheme} onClick={handleAddSysType}>{t('add').toUpperCase()}</CustomLoadingButton>
              )}
            </div>
          </div>
        </motion.div>
      )}
      {isProcessing && (
        <motion.div
          className="processing-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="processing-wrapper">
            <GridLoader color="#bd97fc"
              style={{
                height: "50px",
                width: "50px",
              }}
            />
          </div>
        </motion.div>
      )}
    </div>
  );
};

export default AdSysCode;
